"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */
!function (t, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["modal"] = n() : t["modal"] = n();
}(undefined, function () {
  return function (t) {
    function n(i) {
      if (o[i]) return o[i].exports;var a = o[i] = { i: i, l: !1, exports: {} };return t[i].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }var o = {};return n.m = t, n.c = o, n.i = function (t) {
      return t;
    }, n.d = function (t, o, i) {
      n.o(t, o) || Object.defineProperty(t, o, { configurable: !1, enumerable: !0, get: i });
    }, n.n = function (t) {
      var o = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };return n.d(o, "a", o), o;
    }, n.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, n.p = "./", n(n.s = 4);
  }([function (t, n, o) {
    "use strict";
    function i(t, n) {
      if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
    }n.__esModule = !0, n.Modal = void 0;var a = o(5),
        r = { modalTransition: "my-modal-fade", autoclose: !0, className: "", align: "middle" },
        s = void 0 !== document.body.style.transition,
        l = void 0 !== document.body.style.animation,
        d = "undefined" != typeof Promise,
        u = function u() {},
        c = 0,
        f = "",
        p = !1,
        h = "";n.Modal = function () {
      function t(n) {
        i(this, t), this._handlers = [], this.opts = Object.assign({}, r, n), this._init();
      }return t.prototype._init = function () {
        var t = this;this.wrap = document.createElement("div"), this.wrap.className = "my-modal", this.wrap.innerHTML = '\n    <div class="my-modal__mask"></div>\n    <div class="my-modal__body js-my-modal-body">\n        <div class="my-modal__placeholder"></div><div class="my-modal__dialog js-my-modal-dialog"></div>\n    </div>\n';var n = this.wrap.querySelector(".js-my-modal-dialog");if (n.style.verticalAlign = this.opts.align, n.appendChild(this.opts.el), document.body.appendChild(this.wrap), this.opts.className && this.opts.className.split(/\s+/).forEach(function (n) {
          return (0, a.addClass)(t.wrap, n);
        }), this.opts.autoclose) {
          var o = this.wrap.querySelector(".js-my-modal-body");(0, a.on)(o, "click", function (e) {
            var i = e || window.event,
                a = i.target || i.srcElement;a !== o && a !== n || t.close();
          }, !1);
        }(0, a.on)(this.wrap, "click", function (e) {
          for (var n = e || window.event, o = n.target || n.srcElement; o !== t.wrap;) {
            if ((0, a.hasClass)(o, "js-my-modal-close")) return void t.close();o = o.parentNode;
          }
        });
      }, t.prototype._show = function (t, n, o) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : u;if (n && "string" == typeof n && l) {
          t.style.display = "block";var r = function c(e) {
            e.target === t && ((0, a.removeClass)(t, n + "-enter"), (0, a.off)(t, "animationend", c), i());
          };return (0, a.on)(t, "animationend", r), (0, a.addClass)(t, "" + n), void (0, a.addClass)(t, n + "-enter");
        }if ("function" == typeof n) return void n.call(this, t, "show", i);if (o && "string" == typeof o && s) {
          (0, a.addClass)(t, o + "-enter"), (0, a.addClass)(t, "" + o);var d = function f(e) {
            e.target === t && ((0, a.off)(t, "transitionend", f), i());
          };return (0, a.on)(t, "transitionend", d), t.style.display = "block", void (0, a.raf)(function () {
            (0, a.removeClass)(t, o + "-enter");
          });
        }t.style.display = "block", i();
      }, t.prototype._hide = function (t, n, o) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : u;if (n && "string" == typeof n && l) {
          var r = function c(e) {
            e.target === t && ((0, a.removeClass)(t, n + "-leave"), (0, a.off)(t, "animationend", c), t.style.display = "none", i());
          };return (0, a.on)(t, "animationend", r), void (0, a.addClass)(t, n + "-leave");
        }if ("function" == typeof n) return void n.call(this, t, "hide", i);if (o && "string" == typeof o && s) {
          var d = function f(e) {
            e.target === t && ((0, a.removeClass)(t, o + "-leave"), (0, a.off)(t, "transitionend", f), t.style.display = "none", i());
          };return (0, a.on)(t, "transitionend", d), void (0, a.addClass)(t, o + "-leave");
        }t.style.display = "none", i();
      }, t.prototype.open = function () {
        var t = this,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};0 === c && (p = (0, a.isOverflowing)(), f = (0, a.setPaddingRight)(p), h = document.body.style.overflow, document.body.style.overflow = "hidden"), c++, this.trigger("open");var o = 0,
            i = function i() {
          if (0 === o) return void (o = 1);t.trigger("opened");
        };return this._show(this.wrap, n.modalAnimation || this.opts.modalAnimation, n.modalTransition || this.opts.modalTransition, i), this._show(this.opts.el, n.animation || this.opts.animation, n.transition || this.opts.transition, i), d ? new Promise(function (n) {
          return t._resolve = n;
        }) : void 0;
      }, t.prototype.close = function () {
        var t = this,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};this.trigger("close");var o = 0,
            i = function i() {
          if (0 === o) return void (o = 1);t.trigger("closed"), c--, 0 === c && p && (document.body.style.overflow = h, document.body.style.paddingRight = f), t._resolve && t._resolve();
        };this._hide(this.wrap, n.modalAnimation || this.opts.modalAnimation, n.modalTransition || this.opts.modalTransition, i), this._hide(this.opts.el, n.animation || this.opts.animation, n.transition || this.opts.transition, i);
      }, t.prototype.on = function (t, n) {
        this._handlers.push({ event: t, fn: n });
      }, t.prototype.off = function (t) {
        for (var n = 0; n < this._handlers.length; n++) {
          t === this._handlers[n].event && (this._handlers.splice(n, 1), n--);
        }
      }, t.prototype.trigger = function (t) {
        var n = this;this._handlers.forEach(function (o) {
          o.event === t && o.fn.call(n);
        });
      }, t;
    }();
  }, function (t, n, o) {
    "use strict";
    o(7);
  }, function (t, n, o) {
    n = t.exports = o(3)(), n.push([t.i, ".my-modal {\n  display: none;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  outline: 0;\n  -webkit-overflow-scrolling: touch;\n  opacity: 1;\n  z-index: 10;\n}\n.my-modal--open {\n  overflow: auto;\n}\n.my-modal__mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: .6;\n  filter: alpha(opacity=60);\n  z-index: 1;\n}\n.my-modal__body {\n  overflow: auto;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n.my-modal__dialog {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n}\n.my-modal__placeholder {\n  display: inline-block;\n  height: 100%;\n  width: 0;\n  font-size: 0;\n  letter-spacing: -3px;\n  vertical-align: middle;\n}\n.my-modal-fade {\n  transition: opacity 0.3s ease-out;\n  opacity: 1;\n}\n.my-modal-fade-enter,\n.my-modal-fade-leave {\n  opacity: 0;\n}\n", ""]);
  }, function (t, n) {
    t.exports = function () {
      var t = [];return t.toString = function () {
        for (var t = [], n = 0; n < this.length; n++) {
          var o = this[n];o[2] ? t.push("@media " + o[2] + "{" + o[1] + "}") : t.push(o[1]);
        }return t.join("");
      }, t.i = function (n, o) {
        "string" == typeof n && (n = [[null, n, ""]]);for (var i = {}, a = 0; a < this.length; a++) {
          var r = this[a][0];"number" == typeof r && (i[r] = !0);
        }for (a = 0; a < n.length; a++) {
          var s = n[a];"number" == typeof s[0] && i[s[0]] || (o && !s[2] ? s[2] = o : o && (s[2] = "(" + s[2] + ") and (" + o + ")"), t.push(s));
        }
      }, t;
    };
  }, function (t, n, o) {
    "use strict";
    n.__esModule = !0, n.Modal = void 0, o(1);var i = o(0);n.Modal = i.Modal;
  }, function (t, n, o) {
    "use strict";
    function i() {
      var t = window.innerWidth || document.documentElement.offsetWidth;return document.body.clientWidth < t;
    }function a(t) {
      document.body.style.paddingRight = t;
    }function r(t) {
      var n = document.body.style.paddingRight || 0;return t && (document.body.style.paddingRight = parseInt(n, 10) + p + "px"), n || "";
    }function s() {
      var t = document.createElement("div"),
          n = 0;return t.style.position = "absolute", t.style.top = "-9999px", t.style.width = "50px", t.style.height = "50px", t.style.overflow = "scroll", document.body.appendChild(t), n = t.offsetWidth - t.clientWidth, document.body.removeChild(t), n;
    }function l(t, n, o) {
      t.addEventListener ? t.addEventListener(n, o, !1) : t.attachEvent("on" + n, o);
    }function d(t, n, o) {
      t.removeEventListener ? t.removeEventListener(n, o, !1) : t.detachEvent("on" + n, o);
    }function u(t, n) {
      t.classList ? t.classList.add(n) : f(t, n) || (t.className += " " + n);
    }function c(t, n) {
      if (!t.classList) return (" " + t.className + " ").replace(" " + n + " ", "").trim();t.classList.remove(n);
    }function f(t, n) {
      return t.classList ? t.classList.contains(n) : (" " + t.className + " ").indexOf(" " + n + " ") > -1;
    }n.__esModule = !0, n.isOverflowing = i, n.resetPaddingRight = a, n.setPaddingRight = r, n.measureScrollbar = s, n.on = l, n.off = d, n.addClass = u, n.removeClass = c, n.hasClass = f;var p = n.scrollbarWidth = s();n.raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (t) {
      window.setTimeout(t, 1e3 / 60);
    };
  }, function (t, n) {
    function o(t, n) {
      for (var o = 0; o < t.length; o++) {
        var i = t[o],
            a = p[i.id];if (a) {
          a.refs++;for (var r = 0; r < a.parts.length; r++) {
            a.parts[r](i.parts[r]);
          }for (; r < i.parts.length; r++) {
            a.parts.push(d(i.parts[r], n));
          }
        } else {
          for (var s = [], r = 0; r < i.parts.length; r++) {
            s.push(d(i.parts[r], n));
          }p[i.id] = { id: i.id, refs: 1, parts: s };
        }
      }
    }function i(t) {
      for (var n = [], o = {}, i = 0; i < t.length; i++) {
        var a = t[i],
            r = a[0],
            s = a[1],
            l = a[2],
            d = a[3],
            u = { css: s, media: l, sourceMap: d };o[r] ? o[r].parts.push(u) : n.push(o[r] = { id: r, parts: [u] });
      }return n;
    }function a(t, n) {
      var o = v(),
          i = b[b.length - 1];if ("top" === t.insertAt) i ? i.nextSibling ? o.insertBefore(n, i.nextSibling) : o.appendChild(n) : o.insertBefore(n, o.firstChild), b.push(n);else {
        if ("bottom" !== t.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");o.appendChild(n);
      }
    }function r(t) {
      t.parentNode.removeChild(t);var n = b.indexOf(t);n >= 0 && b.splice(n, 1);
    }function s(t) {
      var n = document.createElement("style");return n.type = "text/css", a(t, n), n;
    }function l(t) {
      var n = document.createElement("link");return n.rel = "stylesheet", a(t, n), n;
    }function d(t, n) {
      var o, i, a;if (n.singleton) {
        var d = y++;o = g || (g = s(n)), i = u.bind(null, o, d, !1), a = u.bind(null, o, d, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (o = l(n), i = f.bind(null, o), a = function a() {
        r(o), o.href && URL.revokeObjectURL(o.href);
      }) : (o = s(n), i = c.bind(null, o), a = function a() {
        r(o);
      });return i(t), function (n) {
        if (n) {
          if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) return;i(t = n);
        } else a();
      };
    }function u(t, n, o, i) {
      var a = o ? "" : i.css;if (t.styleSheet) t.styleSheet.cssText = w(n, a);else {
        var r = document.createTextNode(a),
            s = t.childNodes;s[n] && t.removeChild(s[n]), s.length ? t.insertBefore(r, s[n]) : t.appendChild(r);
      }
    }function c(t, n) {
      var o = n.css,
          i = n.media;if (i && t.setAttribute("media", i), t.styleSheet) t.styleSheet.cssText = o;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }t.appendChild(document.createTextNode(o));
      }
    }function f(t, n) {
      var o = n.css,
          i = n.sourceMap;i && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");var a = new Blob([o], { type: "text/css" }),
          r = t.href;t.href = URL.createObjectURL(a), r && URL.revokeObjectURL(r);
    }var p = {},
        h = function h(t) {
      var n;return function () {
        return void 0 === n && (n = t.apply(this, arguments)), n;
      };
    },
        m = h(function () {
      return (/msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase())
      );
    }),
        v = h(function () {
      return document.head || document.getElementsByTagName("head")[0];
    }),
        g = null,
        y = 0,
        b = [];t.exports = function (t, n) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");n = n || {}, void 0 === n.singleton && (n.singleton = m()), void 0 === n.insertAt && (n.insertAt = "bottom");var a = i(t);return o(a, n), function (t) {
        for (var r = [], s = 0; s < a.length; s++) {
          var l = a[s],
              d = p[l.id];d.refs--, r.push(d);
        }if (t) {
          o(i(t), n);
        }for (var s = 0; s < r.length; s++) {
          var d = r[s];if (0 === d.refs) {
            for (var u = 0; u < d.parts.length; u++) {
              d.parts[u]();
            }delete p[d.id];
          }
        }
      };
    };var w = function () {
      var t = [];return function (n, o) {
        return t[n] = o, t.filter(Boolean).join("\n");
      };
    }();
  }, function (t, n, o) {
    var i = o(2);"string" == typeof i && (i = [[t.i, i, ""]]);o(6)(i, {});i.locals && (t.exports = i.locals);
  }]);
});


//////////////////
// WEBPACK FOOTER
// ../src/js/modal.js
// module id = 1
// module chunks = 0